module.exports = __webpack_public_path__ + "static/media/hand.0e1851c1.svg";